import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CarrerasService } from 'src/app/services/carreras.service';
import { GruposService } from 'src/app/services/grupos.service';
import { DataTablesModule } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from 'src/app/services/login.service';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { V4Service } from 'src/app/services/v4.service';

@Component({
  selector: 'app-grupos',
  templateUrl: './grupos.component.html',
  styleUrls: ['./grupos.component.scss'],
  
})
export class GruposComponent implements OnInit {
  enviroment = environment.BASE_URL;
  grupos = [
    {'nombre':'ITI 20', 'institucion':'UPMH', 'fecha':'2020-11-01', 'representante':'Jaime Perez'},
    {'nombre':'LACP 20', 'institucion':'La Salle Pachuca', 'fecha':'2020-11-01', 'representante':'Maria Dominguez'},
    {'nombre':'IIS 20', 'institucion':'ITP', 'fecha':'2020-11-01', 'representante':'Rubén Valdez'},
    {'nombre':'LDG 20', 'institucion':'UAEH', 'fecha':'2020-11-01', 'representante':'Jade Camacho'},
  ]

  miembros = [
    {'nombre': '', 'celular': '7712025068'},
    {'nombre': 'Ramón Medina', 'celular': '7712025231'},
    {'nombre': '', 'celular': '7712425642'},
    {'nombre': 'Gabriela Sánchez', 'celular': '7714535363'},
  ]

  p: number = 1;
  closeResult: string;
  respuestaCarreras:any;
  respuestaAgregarGrupo:any;
  respuestGrupos:any;
  respuestaMiembros:any;
  respuestaDatosGrupo:any;
  respuestaEstolas:any;
  respuestaFondos:any;
  respuestaSesionesTematicas:any;
  respuestaUpdateGrupo:any;
  respuestaEstatusGrupo:any;
  respuestaInstituciones:any;
  fechaGraduacionAdd =  '';
  fechaEntregaAdd = '';
  fechaFotoAdd = '';
  instituciones;
  datosGrupo;
  carreras;
  pago_tres = null;
  pago_uno  = null;
  pago_dos = null;
  data;
  formulario;
  formularioEdit;
  estolas;
  fondos;
  sesiones;
  grupoid;
  sesion_tematicaid;
  estatus;
  estatusid;
  institucionSelected;
  carreraSelected;
  formularioGrupo;

  respuestaGet:any;
  respuestaPaquetes:any;
  categorias;
  datosCliente;
  filtroGrupos = '1';
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  vendedores:any;
  categoriasG:any = [];
  familiasV2:any[] = [];
  filtroFamiliasV2 = '';
  familiasGrupoV2:any[] = [];
  familiasSeleccionadasV2Ids:number[] = [];
  relacionesFamiliaGrupoV2:any = {};
  cargandoFamiliasV2 = false;
  guardandoFamiliaV2:any = null;

  constructor(private modalService: NgbModal, private _getCarreras: CarrerasService, private _getInstituciones: CarrerasService,
    private _agregarGrupo: GruposService, public iziToast: Ng2IzitoastService,
    private _getGrupos:GruposService, private _getMiembros: GruposService, 
    private _getDatosGrupo: GruposService, private _getEstolas: GruposService,
    private _getSesionesTematicas: GruposService, private _getFondos: GruposService,
    private _updateGrupo: GruposService, private _getEstatusGrupos: GruposService, 
    private _getPaquetes:PaquetesService,
    private _getData:LoginService,
    private _v4: V4Service) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 20,
      processing: true
    };

    this.getCarreras();
    this.getInstituciones();
    this.getGrupos();
    this.getEstolas();
    this.getSesionesTematicas();
    this.getFondos();
    this.getEstatusGrupos();
    this.getDataCliente();
    this.getCategorias();
    this.getVendedores();
    this.getFamiliasV2();
    this.formulario = {
      nombreGrupo: '',
      fechaFoto: '',
      fechaEntrega: '',
      fechaGraduacion: '',
      nombre: '',
      apellidos: '',
      celular: '',
      email: '',
      categoria: '',
      vendedor: '',
    }
    this.formularioEdit = {
      nombre: '',
      carrera: '',
      fecha_graduacion: '',
      fecha_foto: '',
      fecha_entrega: '',
      lugar_entrega: '',
      generacion: '',
      fondo: '',
      sesion_tematica: '',
      fecha_pago_tres:'',
      fecha_pago_dos:'',
      fecha_pago_uno:'',
      categoria: '',
      vendedor: '',
    }


    this.formularioGrupo ={
      fecha_graduacion:''
    } 
  }

  getVendedores(){
    this._getGrupos.getVendedores().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.vendedores = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getDataCliente(){
    this._getData.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
        
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getCarreras(){
    this._getCarreras.getCarreras().subscribe(
      data => {
        this.respuestaCarreras = data;
        if(this.respuestaCarreras.success){
          this.carreras = this.respuestaCarreras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getInstituciones(){
    this._getInstituciones.getInstituciones().subscribe(
      data => {
        this.respuestaInstituciones = data;
        if(this.respuestaInstituciones.success){
          this.instituciones = this.respuestaInstituciones.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
    
  }

  getEstolas(){
    this._getEstolas.getEstolas().subscribe(
      data => {
        this.respuestaEstolas = data;
        if(this.respuestaEstolas.success){
          this.estolas = this.respuestaEstolas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getSesionesTematicas(){
    this._getSesionesTematicas.getSesionesTematicas().subscribe(
      data => {
        this.respuestaSesionesTematicas = data;
        if(this.respuestaSesionesTematicas.success){
          this.sesiones = this.respuestaSesionesTematicas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getFondos(){
    this._getFondos.getFondos().subscribe(
      data => {
        this.respuestaFondos = data;
        if(this.respuestaFondos.success){
          this.fondos = this.respuestaFondos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getEstatusGrupos(){
    this._getEstatusGrupos.getEstatusGrupo().subscribe(
      data => {
        this.respuestaEstatusGrupo = data;
        if(this.respuestaEstatusGrupo.success){
          this.estatus = this.respuestaEstatusGrupo.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getGrupos(){
    this._getGrupos.getGrupos().subscribe(
      data => {
        this.respuestGrupos = data;
        if(this.respuestGrupos.success){
          this.grupos = this.respuestGrupos.content;
          this.dtTrigger.next();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getGruposFiltro(){
    this.data = {
      'estatus': this.filtroGrupos,
    }

    this._getGrupos.getGruposFiltro(this.data).subscribe(
      data => {
        this.respuestGrupos = data;
        if(this.respuestGrupos.success){
          this.dtTrigger.unsubscribe();
          this.grupos = this.respuestGrupos.content;
          this.dtTrigger.next();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  cerrarGrupo(grupo){
    this.data = {
      'grupo': grupo
    }
    this._getGrupos.cerrarGrupo(this.data).subscribe(
      data => {
        this.respuestGrupos = data;
        if(this.respuestGrupos.success){
          this.iziToast.show(
            {
                title: 'Se ha cerrado el grupo correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dtTrigger.unsubscribe();
          this.getGrupos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
    
  }

  getCategorias(){
    this._getPaquetes.getCategorias().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.categorias = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getFamiliasV2(){
    this.cargandoFamiliasV2 = true;
    this._v4.getFamilias().subscribe(
      (data:any) => {
        this.cargandoFamiliasV2 = false;
        if(data.success){
          this.familiasV2 = data.content || [];
        }else{
          alert('No se cargaron las familias');
        }
      }, error => {
        this.cargandoFamiliasV2 = false;
        console.error(error);
      });
  }

  getFamiliasGrupoV2(){
    if(!this.grupoid){
      return;
    }

    this.cargandoFamiliasV2 = true;
    this._v4.getFamiliaGruposPorGrupo(Number(this.grupoid)).subscribe(
      (data:any) => {
        this.cargandoFamiliasV2 = false;
        if(data.success){
          this.familiasGrupoV2 = data.content || [];
          this.familiasSeleccionadasV2Ids = [];
          this.relacionesFamiliaGrupoV2 = {};
          for(var i = 0; i < this.familiasGrupoV2.length; i++){
            var relacion = this.familiasGrupoV2[i];
            var familiaId = Number(relacion.familia);
            if(!Number.isNaN(familiaId)){
              this.familiasSeleccionadasV2Ids.push(familiaId);
              this.relacionesFamiliaGrupoV2[familiaId] = relacion.id;
            }
          }
        }else{
          alert('No se cargaron las familias del grupo');
        }
      }, error => {
        this.cargandoFamiliasV2 = false;
        console.error(error);
      });
  }

  familiaV2Seleccionada(familiaId:number){
    return this.familiasSeleccionadasV2Ids.indexOf(Number(familiaId)) !== -1;
  }

  get familiasV2Seleccionadas(){
    return this.filtrarFamiliasV2(this.familiasV2.filter((familia:any) => this.familiaV2Seleccionada(familia.id)));
  }

  get familiasV2NoSeleccionadas(){
    return this.filtrarFamiliasV2(this.familiasV2.filter((familia:any) => !this.familiaV2Seleccionada(familia.id)));
  }

  filtrarFamiliasV2(familias:any[]){
    var filtro = (this.filtroFamiliasV2 || '').toString().toLowerCase().trim();
    if(!filtro){
      return familias;
    }

    return familias.filter((familia:any) => {
      var nombre = familia.nombre ? familia.nombre.toString().toLowerCase() : '';
      var descripcion = familia.descripcion ? familia.descripcion.toString().toLowerCase() : '';
      return nombre.indexOf(filtro) !== -1 || descripcion.indexOf(filtro) !== -1;
    });
  }

  asignarFamiliaV2(familiaId:number){
    var id = Number(familiaId);
    if(this.familiaV2Seleccionada(id) || !this.grupoid){
      return;
    }

    this.guardandoFamiliaV2 = id;
    this._v4.crearFamiliaGrupo({ familia: id, grupo: this.grupoid }).subscribe(
      (data:any) => {
        this.guardandoFamiliaV2 = null;
        if(data.success){
          this.iziToast.show({
              title: 'Familia asignada',
              titleColor: '#f8f8ff',
              color: '#4CAF50',
              position: 'topRight',
              closeOnEscape: true,
          });
          this.getFamiliasGrupoV2();
        }else{
          alert('No se pudo asignar la familia');
        }
      }, error => {
        this.guardandoFamiliaV2 = null;
        console.error(error);
      });
  }

  quitarFamiliaV2(familiaId:number){
    var id = Number(familiaId);
    var relacionId = this.relacionesFamiliaGrupoV2[id];
    if(!relacionId){
      return;
    }

    this.guardandoFamiliaV2 = id;
    this._v4.eliminarFamiliaGrupo(relacionId).subscribe(
      (data:any) => {
        this.guardandoFamiliaV2 = null;
        if(data.success){
          this.iziToast.show({
              title: 'Familia removida',
              titleColor: '#f8f8ff',
              color: '#4CAF50',
              position: 'topRight',
              closeOnEscape: true,
          });
          this.familiasSeleccionadasV2Ids = this.familiasSeleccionadasV2Ids.filter((item:number) => item !== id);
          delete this.relacionesFamiliaGrupoV2[id];
        }else{
          alert('No se pudo quitar la familia');
        }
      }, error => {
        this.guardandoFamiliaV2 = null;
        console.error(error);
      });
  }


  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  imageChange2(files: FileList){
    this.formulario.imagen2 = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen2.type.toString() == 'image/png' ||
        this.formulario.imagen2.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen2.size > 10485760) {
          this.formulario.imagen2 = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen2);
    } else {
      this.formulario.imagen2 = null;
      $('#imagen').focus();
      return;
    }
  }

  getMiembrosGrupo(grupo){
    this.data = {
      'grupo':grupo,
    }
    this._getMiembros.getMiembros(this.data).subscribe(
      data => {
        this.respuestaMiembros = data;
        if(this.respuestaMiembros.success){
          this.miembros = this.respuestaMiembros.content;
          document.getElementById('click').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarGrupo(carrera, institucion){
    
    if (this.formulario.fechaGraduacion['year'] != undefined){
      this.fechaGraduacionAdd = this.formulario.fechaGraduacion['year']+'-'+this.formulario.fechaGraduacion['month']+'-'+this.formulario.fechaGraduacion['day'];
    }

    if (this.formulario.fechaEntrega['year'] != undefined){
      this.fechaEntregaAdd = this.formulario.fechaEntrega['year']+'-'+this.formulario.fechaEntrega['month']+'-'+this.formulario.fechaEntrega['day']
    }

    if (this.formulario.fechaFoto['year'] != undefined){
      this.fechaFotoAdd = this.formulario.fechaFoto['year']+'-'+this.formulario.fechaFoto['month']+'-'+this.formulario.fechaFoto['day'];
    }

    
    
    this.data = {
      'carrera': carrera,
      'institucion': institucion,
      'nombreGrupo': this.formulario.nombreGrupo,
      'categoria': this.formulario.categoria,
      'fechaFoto':  this.fechaFotoAdd,
      'fechaEntrega': this.fechaEntregaAdd,
      'fechaGraduacion': this.fechaGraduacionAdd,
      'first_name': this.formulario.nombre,
      'last_name': this.formulario.apellidos,
      'celular': this.formulario.celular,
      'email': this.formulario.email,
      'vendedor': this.formulario.vendedor,
      'password': this.formulario.celular,
    }

    if (this.formulario.celular != ''){
      this._agregarGrupo.agregarGrupo(this.data).subscribe(
        data => {
          this.respuestaAgregarGrupo = data;
          if(this.respuestaAgregarGrupo.success){
            this.iziToast.show(
              {
                  title: 'Se ha agregado el cliente correctamente.',
                  titleColor: '#f8f8ff',
                  color: '#4CAF50',
                  position: 'topRight',
                  closeOnEscape: true,
              });
            this.formulario.nombre = '';
            this.formulario.apellidos = '';
            this.formulario.celular = '';
            this.formulario.email = '';
            this.formulario.nombreGrupo = '';
            this.formulario.fechaFoto = '';
            this.formulario.fechaEntrega = '';
            this.dtTrigger.unsubscribe();
            this.dismissAll();
            this.getGrupos();
          }else {
            alert('No se cargaron los datos');
          }
        }, error => console.error(error));
    }else{
      this.iziToast.show(
        {
            title: 'Por favor agrega un número telefónico.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
    }
  }

  getDatosGrupo(grupo){
    this.data = {
      'grupo':grupo
    }

    this._getDatosGrupo.getDatosGrupo(this.data).subscribe(
      data => {
        this.respuestaDatosGrupo = data;
        if(this.respuestaDatosGrupo.success){
          this.datosGrupo = this.respuestaDatosGrupo.content;
          this.categoriasG = this.respuestaDatosGrupo.content.categorias;
          this.grupoid = this.datosGrupo.id;
          this.filtroFamiliasV2 = '';
          this.getFamiliasGrupoV2();
          console.log(this.categoriasG);
          document.getElementById('click2').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  actualizarGrupo(grupo){
    this.data = {
      'grupo':grupo
    }
    this.formularioEdit.forma_pago = 0;

    this._getDatosGrupo.getDatosGrupo(this.data).subscribe(
      data => {
        this.respuestaDatosGrupo = data;
        if(this.respuestaDatosGrupo.success){
          this.datosGrupo = this.respuestaDatosGrupo.content;
          this.dismissAll();
          this.formularioEdit.nombre_grupo = this.datosGrupo.nombre;
          this.formularioEdit.fecha_graduacion = this.datosGrupo.fecha_graduacion;
          this.formularioEdit.fecha_foto = this.datosGrupo.fecha_foto;
          this.formularioEdit.fecha_entrega = this.datosGrupo.fecha_entrega;
          this.formularioEdit.lugar_entrega = this.datosGrupo.lugar_entrega;

          this.formularioEdit.hora_foto = this.datosGrupo.hora_toma_foto;
          this.formularioEdit.lugar_foto = this.datosGrupo.lugar_toma_foto;
          this.formularioEdit.link_whatsapp = this.datosGrupo.link_whatsapp;
          this.formularioEdit.promociones = this.datosGrupo.promociones;
          this.formularioEdit.numero_personas = this.datosGrupo.numero_personas;

          

          if(this.datosGrupo.forma_pago != null){
            this.formularioEdit.forma_pago = this.datosGrupo.forma_pago;
          }

          this.formularioEdit.fecha_pago_uno = this.datosGrupo.fecha_pago_uno;
          if (this.formularioEdit.fecha_pago_uno != null){
            var anio_pago1 = this.formularioEdit.fecha_pago_uno.split('-')[0];
            var mes_pago1 = this.formularioEdit.fecha_pago_uno.split('-')[1];
            var dia_pago1 = this.formularioEdit.fecha_pago_uno.split('-')[2];

            anio_pago1 = parseInt(anio_pago1, 10);
            mes_pago1 = parseInt(mes_pago1, 10);
            dia_pago1 = parseInt(dia_pago1, 10);

            this.formularioEdit.fecha_pago_uno =  {year: anio_pago1, month: mes_pago1, day: dia_pago1};
          }

          this.formularioEdit.fecha_pago_dos = this.datosGrupo.fecha_pago_dos;
          if (this.formularioEdit.fecha_pago_dos != null){
            var anio_pago2 = this.formularioEdit.fecha_pago_dos.split('-')[0];
            var mes_pago2 = this.formularioEdit.fecha_pago_dos.split('-')[1];
            var dia_pago2 = this.formularioEdit.fecha_pago_dos.split('-')[2];

            anio_pago2 = parseInt(anio_pago2, 10);
            mes_pago2 = parseInt(mes_pago2, 10);
            dia_pago2 = parseInt(dia_pago2, 10);

            this.formularioEdit.fecha_pago_dos =  {year: anio_pago2, month: mes_pago2, day: dia_pago2};
          }


          this.formularioEdit.fecha_pago_tres = this.datosGrupo.fecha_pago_tres;
          if (this.formularioEdit.fecha_pago_tres != null){
            var anio_pago3 = this.formularioEdit.fecha_pago_tres.split('-')[0];
            var mes_pago3 = this.formularioEdit.fecha_pago_tres.split('-')[1];
            var dia_pago3 = this.formularioEdit.fecha_pago_tres.split('-')[2];

            anio_pago3 = parseInt(anio_pago3, 10);
            mes_pago3 = parseInt(mes_pago3, 10);
            dia_pago3 = parseInt(dia_pago3, 10);

            this.formularioEdit.fecha_pago_tres =  {year: anio_pago3, month: mes_pago3, day: dia_pago3};
          }
          



                    
          if (this.formularioEdit.hora_foto != null){
            var hora = this.formularioEdit.hora_foto.split(':')[0];
            var minutos = this.formularioEdit.hora_foto.split(':')[1];
            hora = parseInt(hora, 10);
            minutos = parseInt(minutos, 10);
            this.formularioEdit.hora_foto =  {hour: hora, minute: minutos};
          }else{
            this.formularioEdit.hora_foto =  {hour: 0, minute: 0};
          }
          
          

          this.formularioEdit.generacion = this.datosGrupo.generacion;
          this.formularioEdit.fondo = this.datosGrupo.fondo;
          this.formularioEdit.sesion_tematica = this.datosGrupo.sesion_tematica;
          this.formularioEdit.estola = this.datosGrupo.estola;
          this.sesion_tematicaid = this.datosGrupo.sesion_tematicaid;
          this.estatusid = this.datosGrupo.estatus_grupoid;
          this.institucionSelected = this.datosGrupo.escuelaid;
          this.carreraSelected = this.datosGrupo.carreraid;
          this.grupoid = this.datosGrupo.id;
          document.getElementById('click3').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  updateGrupo(grupo, institucion, carrera, estola,  fondo, tematica, estatus_grupo){
    this.pago_uno = '';
    this.pago_dos = '';
    this.pago_tres = '';
    const formData = new FormData();

    if (this.formularioEdit.fecha_pago_tres != null){
      this.pago_tres = this.formularioEdit.fecha_pago_tres['year']+'-'+this.formularioEdit.fecha_pago_tres['month']+'-'+this.formularioEdit.fecha_pago_tres['day']
    }

    if (this.formularioEdit.fecha_pago_uno != null){
      this.pago_uno = this.formularioEdit.fecha_pago_uno['year']+'-'+this.formularioEdit.fecha_pago_uno['month']+'-'+this.formularioEdit.fecha_pago_uno['day'];
    }

    if (this.formularioEdit.fecha_pago_dos != null){
      this.pago_dos = this.formularioEdit.fecha_pago_dos['year']+'-'+this.formularioEdit.fecha_pago_dos['month']+'-'+this.formularioEdit.fecha_pago_dos['day'];
    }

    if (this.formulario.imagen){ 
      formData.append('escudo', this.formulario.imagen);
    }

    if (this.formulario.imagen2){ 
      formData.append('escudo2', this.formulario.imagen2);
    }

    formData.append('grupo', grupo);
    formData.append('estola', estola);
    formData.append('fondo', fondo);
    formData.append('institucion', institucion);
    formData.append('carrera', carrera);
    formData.append('estatus_grupo', estatus_grupo);
    formData.append('tematica', tematica);
    formData.append('nombre_grupo', this.formularioEdit.nombre_grupo);
    formData.append('categoria', this.formularioEdit.categoria);
    formData.append('generacion', this.formularioEdit.generacion);
    formData.append('fecha_graduacion', this.formularioEdit.fecha_graduacion);
    formData.append('fecha_foto', this.formularioEdit.fecha_foto);
    formData.append('fecha_entrega', this.formularioEdit.fecha_entrega);
    formData.append('lugar_entrega', this.formularioEdit.lugar_entrega);
    formData.append('hora_toma_foto', this.formularioEdit.hora_foto['hour']+':'+this.formularioEdit.hora_foto['minute']);
    formData.append('lugar_foto', this.formularioEdit.lugar_foto);
    formData.append('link_whatsapp', this.formularioEdit.link_whatsapp);
    formData.append('numero_personas', this.formularioEdit.numero_personas);
    formData.append('promociones', this.formularioEdit.promociones);
    formData.append('forma_pago', this.formularioEdit.forma_pago);
    formData.append('fecha_pago_uno', this.pago_uno);
    formData.append('fecha_pago_dos', this.pago_dos);
    formData.append('fecha_pago_tres', this.pago_tres);
    
    // this.data = {
    //   'grupo': grupo, 
    //   'estola': estola,
    //   'fondo': fondo,
    //   'institucion': institucion,
    //   'carrera': carrera,
    //   'estatus_grupo': estatus_grupo,
    //   'sesion_tematica': tematica,
    //   'nombre_grupo': this.formularioEdit.nombre_grupo,
    //   'generacion': this.formularioEdit.generacion,
    //   'fecha_graduacion': this.formularioEdit.fecha_graduacion,
    //   'fecha_foto': this.formularioEdit.fecha_foto,
    //   'fecha_entrega': this.formularioEdit.fecha_entrega,
    //   'lugar_entrega': this.formularioEdit.lugar_entrega,
    //   'hora_toma_foto': this.formularioEdit.hora_foto['hour']+':'+this.formularioEdit.hora_foto['minute'],
    //   'lugar_toma_foto': this.formularioEdit.lugar_foto,
    //   'link_whatsapp': this.formularioEdit.link_whatsapp,
    //   'numero_personas': this.formularioEdit.numero_personas,
    //   'promociones': this.formularioEdit.promociones,
    //   'forma_pago':this.formularioEdit.forma_pago,
    //   'fecha_pago_uno': this.pago_uno,
    //   'fecha_pago_dos': this.pago_dos,
    //   'fecha_pago_tres':this.pago_tres,
    // }

    // this._updateGrupo.updateGrupo(this.data).subscribe(
    this._updateGrupo.updateGrupo(formData).subscribe(
      data => {
        this.respuestaUpdateGrupo = data;
        if(this.respuestaUpdateGrupo.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el grupo correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getGrupos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  eliminarGrupo(grupo){
    this.data = {
      'grupo':grupo
    }

    this._updateGrupo.eliminarGrupo(this.data).subscribe(
      data => {
        this.respuestaUpdateGrupo = data;
        if(this.respuestaUpdateGrupo.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminar el grupo correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dtTrigger.unsubscribe();
          this.getGrupos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  confirmarAvance(grupo){
    this.data = {
      'grupo':grupo
    }

    this._updateGrupo.confirmarAvance(this.data).subscribe(
      data => {
        this.respuestaUpdateGrupo = data;
        if(this.respuestaUpdateGrupo.success){
          this.iziToast.show(
            {
                title: 'Se han confirmado los avances.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  openModal2(modal) {
    this.modalService.open(modal, {size: 'lg'});
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
